import { useEffect } from "react";
import styled from "styled-components";
import NotebookPage from "./img/openletter.png"

function MessageLetter(props) {

    let normalView = false;

    function letterPerspercitveChange(event){

        let letter = event.target.previousSibling.previousSibling;
        let page = event.target.previousSibling;

        if(normalView == false) {

            letter.style = "transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg); box-shadow: 0px 0px 0px 1px black; opacity: 1";

            page.style = "transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg) translate(0px, 100px); filter: drop-shadow(0px 0px 0px rgba(0,0,0,1)); opacity: 1";

            normalView = true;
            return;
        } else {

            letter.style = "transform: rotateX(35deg) rotateY(25deg) rotateZ(-20deg); box-shadow: -10px 10px 20px 0px black; opacity: 1";

            page.style = "transform: rotateX(35deg) rotateY(25deg) rotateZ(-20deg) translate(-30px, 100px); filter: drop-shadow(-50px 50px 20px rgba(0,0,0,1)); opacity: 1";

            normalView = false;
            return;
        }
    }

    useEffect(() => {
        setTimeout(() => document.getElementById("Letter").style = "transform: rotateX(35deg) rotateY(25deg) rotateZ(-20deg) translate(0px, 0px); opacity: 1", 100)
    },[])

    return(
        <MasterContainer>
            
            <LetterContainer id="Letter">
                <h1>{props.title}</h1>
                <span><b>Para:</b> {props.name}</span>
                <br/><br/><br/>
                <Span>{props.content}</Span>
                <br/><br/><br/>
                <span>Atenciosamente,<br/></span>
                <span><b>{props.messageFrom}</b></span><br/>
            </LetterContainer>
            <OpenLetter />

            <Button onClick={(event) => letterPerspercitveChange(event)}>Mudar Vista</Button>
        </MasterContainer>

    )
}

export default MessageLetter;

const MasterContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    persperctive: none;
    margin-bottom: 20px;

    @media(max-width: 1000px) {
      scale: .8;
    }

`

const LetterContainer = styled.div`
    width: 435px;
    height: 600px;
    background-color: rgb(255, 255, 255);
    //background-image: url(${NotebookPage});
    //background-size: cover;
    //background-repeat: no-repeat;
    //background-position: center;
    padding: 50px;
    transition: .3s ease-in-out;
    transform: rotateX(35deg) rotateY(25deg) rotateZ(-20deg) translate(100px, 100px);
    box-shadow: -10px 10px 20px 0px rgba(0,0,0,1);
    border: solid 1px;
    font-size: 14pt;
    margin-bottom: 50px;
    opacity: 1;
    font-family: Copperplate, Papyrus, fantasy;
    z-index: 1;
    
`

const Span = styled.span`
`


const OpenLetter = styled.div`
    width: 735px;
    height: 700px;
    //background-color: rgb(255, 255, 255);
    background-image: url(${NotebookPage});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    transition: .3s ease-in-out;
    transform: rotateX(35deg) rotateY(25deg) rotateZ(-20deg) translate(-30px, 100px);
    filter: drop-shadow(-50px 50px 20px rgba(0,0,0,1));
    position: absolute; 
`

const Button = styled.button`
    padding: 10px 50px;
    cursor: pointer;
    z-index: 2;
    font-size: 14pt;
`
